import { useContext } from "react";
import { CommonContext } from "contexts/CommonContext";

export const useCommonContext = () => useContext(CommonContext);

export default useCommonContext;
